import { Flex, Slider, Text } from "@mantine/core";

import { calculatePercent, toCurrencyPrice, toPrice } from "../utils/number.ts";

interface Props {
  value1: string | number | null | undefined;
  value2: string | number | null | undefined;
}

export default function NumberProgressSlider({ value1, value2 }: Props) {
  const val1Num = isNaN(Number(value1)) ? 0 : Number(value1);
  const val2Num = isNaN(Number(value2)) ? 0 : Number(value2);
  return (
    <Flex gap={20} w="100%" h="100%" justify="flex-end" direction="row">
      <Text w="40%">
        {toCurrencyPrice(val1Num)} / {toPrice(val2Num)}
      </Text>
      <Slider
        w="50%"
        maw="320px"
        value={val1Num}
        max={val2Num}
        min={0}
        thumbSize={0.01}
        disabled
      />
      <Text w="10%">{calculatePercent(val1Num, val2Num).toFixed(2)}%</Text>
    </Flex>
  );
}
